import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { VehiclesState } from '../../store/vehicle/vehicle.reducer';
import { AddVehicleFormComponent } from './add-vehicle-form/add-vehicle-form.component';
import * as fromSelectors from '../../store/vehicle/vehicle.selectors';
import * as fromActions from '../../store/vehicle/vehicle.actions';
import { getCarImageAbsoluteURL, setDefaultImg, unsubscribeSubscriptions, countryCd, isAspCrmIntegrationEnabled, environment } from '../../shared/services/util.service';
import { ITestDriveVehicleInventory, ISyncStatus, SourceSystem, Brand } from '@signal/asp-data-commons';
import {MatTableDataSource} from '@angular/material/table';
import {animate, state, style, transition, trigger} from '@angular/animations';
import { Clipboard } from '@angular/cdk/clipboard';
import {TranslateService} from '@ngx-translate/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { EditLicensePlateComponent } from './edit-license-plate/edit-license-plate.component';
import { SubscriptionList } from '../../shared/models/asp.types';
import { DateAdapter } from '@angular/material/core';
import { LuxonDateAdapter } from '../../shared/services/luxon-date-adapter';
import { AlertService } from '../../shared/services/alert.service';
import { ConfirmDialogComponent } from '../../shared/components/confirm-dialog/confirm-dialog.component';
import { BdcDashboardState } from '../../store/bdcdashboard/bdcdashboard.reducer';
import { LoadPendingAppointments } from '../../store/bdcdashboard/bdcdashboard.actions';
import { selectPendingAppointmentsCount } from '../../store/bdcdashboard/bdcdashboard.selectors';
import { DateTime } from 'luxon';
import { Router } from '@angular/router';


@Component({
  selector: 'app-vehicle-management',
  templateUrl: './vehicle-management.component.html',
  styleUrls: ['./vehicle-management.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})

export class VehicleManagementComponent implements OnInit, OnDestroy { 
  readonly maxBulkStatusUpdateCount = 100;
  vehicles: any;
  isLoading$: Observable<boolean>;
  dataSource: any;
  setDefaultImg=setDefaultImg;
  isLmex:boolean = !countryCd.toUpperCase().includes('US');
  initColumns: any[] = [{ id: 'model', display: 'vehicleManagement.modelTrim' }, { id: 'status', display: 'opcodeServiceManagement.status' },
  { id: 'nextTestDriveDate', display: 'vehicleManagement.nextTestDrive' }, { id: 'year', display: 'testDrive.year' },
  { id: 'make', display: 'service.make' }, { id: 'vin', display: 'VIN' },
  { id: 'licensePlate', display: this.isLmex ? 'vehicleManagement.licensePlate' : 'testDrive.stockNo'}];

  initColumnsForFilter: any[] = [{id:'expandFilter', display :''}, {id :'modelFilter', display : 'testDrive.model'},
  {id:'statusFilter', display: ''},{id:'nextTestDriveDateFilter', display: 'vehicleManagement.nextTestDrive'}, {id :'yearFilter', display: 'testDrive.year'},
  {id:'makeFilter', display: 'service.make'}, {id:'vinFilter', display: 'VIN'}, {id:'licensePlateFilter', display: 'testDrive.stockNo' /*'vehicleManagement.licensePlate'*/} ];

  columnsToDisplayWithExpand = ['expand','model','status','nextTestDriveDate', 'year', 'make', 'vin', 'licensePlate'];
  columnsToDisplayForFilter = ['expandFilter', 'modelFilter', 'statusFilter', 'nextTestDriveDateFilter', 'yearFilter', 
  'makeFilter', 'vinFilter', 'licensePlateFilter'];
  
  searchForm: UntypedFormGroup;
  statusOptions = [{id: 'true', display: 'servicePersonnel.online'}, {id: 'false', display :'vehicleManagement.offline' }];

  selectedVehicle: ITestDriveVehicleInventory ;
  isEnglishText : boolean = true;
  expandedElements : any[] = [];
  vehicleForm: UntypedFormGroup;
  disableForm: boolean;
  subscriptions: SubscriptionList = {};
  allRowsExpanded : boolean = false;
  allVehiclesCount$ : Observable<number>;
  pageSizeOptions: number[] =[5, 10, 20]  
  pageIndex: number = 0;
  pageSize: number = 20;
  isExpandedViewAllowed = false;
  selectedVehicles : any[] = [];
  allVehicles: any[] = [];
  searchValues  = [];
  isBulkStatusLoading$: Observable<boolean>;
  bulkStatusInProgress: boolean | null = null;
  refreshInterval;
  refreshFailedCounter:number = 1;
  isSearchLoading = false;
  syncStatus$: Observable<ISyncStatus>;
  private deleteConfig = {
    width: '400px',
    panelClass: 'asp-modal-container'
  };
  invOnlineVehicle: number;
  isCrmIntegrated:boolean;
  viewMode : string =  !this.isLmex ? SourceSystem.NVI : SourceSystem.ME;
  deletePendingAppointmentsCount = 0;
  pendingAppointmentCount$: Observable<number>;
  unavailableVehicleWindow=false;
  isSyncInProgress = false;
  showCount = {} as any;
  isLexus = environment.brand === Brand.LEXUS.toLocaleLowerCase();
  isTabDataLoading;

  constructor(public dialog: MatDialog,
    private readonly vehiclesState: Store<VehiclesState>,
    private readonly copy: Clipboard,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly translate: TranslateService,
    private luxonAdapter: LuxonDateAdapter,
    private readonly alertService: AlertService,
    private readonly dateAdapter: DateAdapter<Date>,
    private readonly BdcDashboardStateStore: Store<BdcDashboardState>,
    private readonly cdr: ChangeDetectorRef,
    private readonly route:Router
    ) {
    this.dateAdapter.setLocale(this.translate.currentLang);
      if(this.translate.currentLang?.includes('es')){
        this.isEnglishText = false;
      }
      this.unavailableVehicleWindow=route.url.includes('appointment-conflicts');
    }

  ngOnInit(): void {
    this.isCrmIntegrated = isAspCrmIntegrationEnabled;
    this.disableForm = true;
    this.isLoading$ = this.vehiclesState.select(fromSelectors.selectLoading);
    this.isBulkStatusLoading$ = this.vehiclesState.select(fromSelectors.selectBulkStatusLoading);
    this.syncStatus$ = this.vehiclesState.select(fromSelectors.selectSyncStatus);
    this.subscriptions.syncStatus = this.syncStatus$.subscribe(data => {
      if (data && (data.status === 'SYNC_FAILED' || data.status === 'SYNC_COMPLETED')) {
        clearInterval(this.refreshInterval);
      }
    })
    this.setupStore();
    this.InitializeSearchForm();
    if (this.unavailableVehicleWindow) {
      this.viewMode = 'Delete Pending';
      this.loadView(this.viewMode);
    }
  }

  setupStore() {
    // this.vehiclesState.dispatch(new fromActions.LoadVehicles({offset: 0, limit: this.pageSize}));
    this.vehiclesState.dispatch(new fromActions.LoadAllVehicles({view: !this.isLmex ? this.viewMode : SourceSystem.ME}));
    this.BdcDashboardStateStore.dispatch(new LoadPendingAppointments({ type : 'deletePending'}));
    this.allVehiclesCount$ = this.vehiclesState.select(fromSelectors.selectVehiclesCount);
    this.subscriptions.vehicleData = this.vehiclesState.select(fromSelectors.selectAllVehicles).subscribe(data => {
      this.vehicles = data;
      if (this.vehicles.length) {
        this.showCount = this.vehicles.reduce((acc, data) => {
          acc.totalVehicles += data.value.length;
          acc.onlineVehicles += data.value.filter(v => v.status).length;
          acc.offlineVehicles += data.value.filter(v => !v.status).length;
          return acc;
        }, { totalVehicles: 0, onlineVehicles: 0, offlineVehicles: 0 });
      }
      this.dataSource = new MatTableDataSource(this.vehicles);
      this.isExpandedViewAllowed =  this.vehicles?.some(x=> x.value.length > 1);
      this.isSearchLoading = false;
    });
    this.subscriptions.allVehicles = this.vehiclesState.select(fromSelectors.selectVehicles).subscribe(data => {
      if(data && data?.length){
        this.allVehicles = data;
      }
    });
    this.subscriptions.onlineVehicleCount = this.vehiclesState.select(fromSelectors.selectOnlineVehiclesCount).subscribe((onVehicles) => {
      if(onVehicles!=null) {
        this.invOnlineVehicle = onVehicles.length;
      } else {
        this.invOnlineVehicle = NaN;
      }
    });

    this.pendingAppointmentCount$ = this.BdcDashboardStateStore.select(selectPendingAppointmentsCount);
  }

  vehicleSelected(vehicle: ITestDriveVehicleInventory){
    if(this.selectedVehicle?.vin !== vehicle.vin) {
      this.disableForm = false;
      this.selectedVehicle = vehicle;
      this.InitializeForm();
    }
    else{
      this.disableForm = true;
      this.selectedVehicle = null;
    }
  }

  onCopyDetails(vin: string){
    return this.copy.copy(vin);
  }

  getImage(vehicle: ITestDriveVehicleInventory){
    return getCarImageAbsoluteURL(vehicle?.imageUrl);
  }

  toggleRow(row) {
    const index = this.expandedElements.findIndex(x => x.vin === row.vin);
    if (index === -1) {
      this.expandedElements.push(row);
    } else {
      this.expandedElements.splice(index, 1);
    }
  }

  isExpanded(row): string {
    if ( this.expandedElements.findIndex(x => x.vin === row.vin) !== -1 || this.allRowsExpanded) {
      return 'expanded';
    }
    return 'collapsed';
  }

  mouseEnter(element: any) {
    const dialogRef = this.dialog.open(EditLicensePlateComponent, {
      data: {licensePlate: element.licensePlate},
      disableClose:true
    });

    this.subscriptions.dialogRef = dialogRef.afterClosed().subscribe(result => {
      if(!!result) {
        const valVehicle = {...element,...result};
        this.vehiclesState.dispatch(new fromActions.UpdateVehicle({vehicle:valVehicle}));
      }
     });
  }

  autoRefreshSyncStatus() {
    this.refreshInterval = setInterval(() => {
      this.subscriptions.selectSyncStatus = this.vehiclesState.select(fromSelectors.selectSyncStatus).subscribe(data => { 
        if (data && data.status === 'SYNC_IN_PROGRESS' && this.isSyncInProgress) {
          // This action will be dispatched after 1 second. This is to reduce the no of calls
          setTimeout(() => {
            this.vehiclesState.dispatch(new fromActions.LoadSyncStatus());
          }, 1000);
        }
        else if(data && data.status === 'SYNC_FAILED'){
          this.isSyncInProgress = false;
          clearInterval(this.refreshInterval);
          
        }
        else if(data && data.status === 'SYNC_COMPLETED' && this.isSyncInProgress) {
          this.isSyncInProgress = false;
          clearInterval(this.refreshInterval);
          if(data.message === 'Sync completed with no data'){
            this.alertService.showAlert(`otherTexts.syncCompletedWithNoVehiclesToSync`, '', '', 5000, false);
          }
          this.alertService.showAlert('otherTexts.syncedSuccessfully', '', '', 5000, false);
          this.vehiclesState.dispatch(new fromActions.LoadAllVehicles({view: this.viewMode}));
          this.InitializeSearchForm();
          this.disableForm = true;
          this.selectedVehicle = null;
          this.expandedElements = [];
          this.selectedVehicles = [];
          this.searchValues = [];
        }else{
          this.isSyncInProgress = false;
          clearInterval(this.refreshInterval); 
        }
      })
    }, 10 * 1000)
  }

  addNewVehicle(){
    if(this.isLmex){
      this.vehiclesState.dispatch(new fromActions.UpdateFromCrm());
      this.isSyncInProgress = true;
      this.autoRefreshSyncStatus();
      return;
    };
    const dialogRef = this.dialog.open(AddVehicleFormComponent, {
      width: '650px',
      height: '650px',
      panelClass: 'asp-modal-container',
      disableClose:true,
      data:{clicked:true}
    });

    this.subscriptions.addVehicleDialog = dialogRef.afterClosed().subscribe(result => {
      
     });
  }

  InitializeForm() {
    this.vehicleForm = this.formBuilder.group({
      status: [false]
    })
    this.vehicleForm.get('status').patchValue(this.selectedVehicle?.expiredAt ? false : this.selectedVehicle?.status);
  }

  updateSwitchValues(val: boolean) {
    this.vehicleForm.get('status').patchValue(val);
    const vehicle: any = {...this.selectedVehicle, status: val};
    this.selectedVehicle = vehicle;
    if(this.viewMode === SourceSystem.ME){
      this.vehiclesState.dispatch(new fromActions.UpdateVehicle({vehicle, isLoadNotification: vehicle?.nextTestDriveDate && !vehicle?.expiredAt}));
    }else if(this.viewMode === SourceSystem.NVI){
      this.vehiclesState.dispatch(new fromActions.UpdateNVIStatus({vehicle}));
    }
    else{
      this.vehiclesState.dispatch(new fromActions.UpdateUVIStatus({vehicle}));
    }
  }

  private getVehiclesForBulkStatusChange(targetStatus: boolean) {
    return this.selectedVehicles.filter(vehicle => vehicle?.status !== targetStatus);
  }

  private getBulkStatusSource() {
    switch (this.viewMode) {
      case SourceSystem.NVI:
        return SourceSystem.NVI;
      case SourceSystem.UVI:
        return SourceSystem.UVI;
      default:
        return 'Manual';
    }
  }

  private getBulkStatusPayload(vehicles: any[], targetStatus: boolean) {
    switch (this.viewMode) {
      case SourceSystem.NVI:
        return vehicles
          .filter(vehicle => vehicle?.unitId !== undefined && vehicle?.unitId !== null && vehicle?.unitId !== '')
          .map(vehicle => `${vehicle.unitId}`);
      case SourceSystem.UVI:
        return vehicles
          .filter(vehicle => !!vehicle?.vin)
          .map(vehicle => vehicle.vin);
      default:
        return vehicles
          .filter(vehicle => !!vehicle?.vin)
          .map(vehicle => ({ ...vehicle, status: targetStatus }));
    }
  }

  private getBulkStatusEligibleCount(targetStatus: boolean) {
    const vehicles = this.getVehiclesForBulkStatusChange(targetStatus);
    return this.getBulkStatusPayload(vehicles, targetStatus).length;
  }

  shouldShowBulkStatusLimitWarning() {
    return this.getBulkStatusEligibleCount(true) > this.maxBulkStatusUpdateCount
      || this.getBulkStatusEligibleCount(false) > this.maxBulkStatusUpdateCount;
  }

  isBulkStatusBtnEnable(targetStatus: boolean) {
    const eligibleCount = this.getBulkStatusEligibleCount(targetStatus);
    return eligibleCount > 0 && eligibleCount <= this.maxBulkStatusUpdateCount;
  }

  onExpandedViewChecked() {
    this.allRowsExpanded = !this.allRowsExpanded;
    this.expandedElements =[];
  }

  // onRecordsPerPageChange(value : number) {
  //   this.pageSize = value;
  //   this.OnLoadNextPageData();
  // }

  // onPageChange(pageEvent : PageEvent){
  //   this.pageIndex = pageEvent.pageIndex;
  //   this.OnLoadNextPageData();
  // }

  // OnLoadNextPageData(){
  //   this.vehiclesState.dispatch(new fromActions.LoadVehicles({offset : this.pageIndex * this.pageSize, 
  //     limit: this.pageSize}))
  //     this.disableForm = true;
  //     this.selectedVehicle = null;
  //     this.expandedElements =[];
  // }

  isAllSelected() {
    const numSelected = this.selectedVehicles.length;
    const numRows = this.allVehicles.length;
    return numSelected === numRows;
  }

  isVehicleSelected(vehicle, isIndeterminate = false){
    if(vehicle.length > 1) {
      const vins = vehicle.map(x=> x.vin);
      const selectedRows = this.selectedVehicles.filter(x=> vins.includes(x.vin))?.length;
      return isIndeterminate ? (selectedRows > 0) && (vehicle.length !== selectedRows) : 
      vehicle.length === selectedRows;
    }
    else {
      return this.selectedVehicles.findIndex(x => x.vin === vehicle.vin) === -1 ? false : true;
    }
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selectedVehicles= [];
      return;
    }
    this.selectedVehicles = [];
    this.selectedVehicles.push(...this.allVehicles);
  }

  toggleSelectedVehicle(vehicle){
    if(vehicle.length > 1) {
      const isAllSelected = this.isVehicleSelected(vehicle);
      vehicle.forEach(element => {
      const index = this.selectedVehicles.findIndex(x => x.vin === element.vin);
      if(isAllSelected) {
        this.selectedVehicles.splice(index, 1);
      }
      else if(index === -1){
        this.selectedVehicles.push(element);
      }
      })        
      }
      else {
        const index = this.selectedVehicles.findIndex(x => x.vin === vehicle.vin);
        index === -1 ? this.selectedVehicles.push(vehicle) : this.selectedVehicles.splice(index, 1);
      }
  }
    
  toggleVehicle(vehicle, index: number){
    if (index === -1) {
      this.selectedVehicles.push(vehicle);
    } else {
      this.selectedVehicles.splice(index, 1);
    }
  }

  onDeleteSelected() {
    let popupBodyText;
      if(this.selectedVehicles.length === 1){
        popupBodyText = this.selectedVehicles[0]?.nextTestDriveDate ? 
      'vehicleManagement.theSelectedVehicleHasScheduledTestDriveAppointmentDoYouStillWantToDeleteIt' :
      'vehicleManagement.doYouWantToDeleteTheSelectedVehicle';
      }
      else if (this.selectedVehicles.length > 1) {
        const vehicleWithAppt = this.selectedVehicles.filter(x=> x?.nextTestDriveDate);
        if( vehicleWithAppt.length === 1) {
          popupBodyText = `${this.translate.instant('vehicleManagement.theFollowingVehicleHasScheduledTestDriveAppointmentDoYouStillWantToDeleteThem')}<br><br>${vehicleWithAppt[0].vin}`;
        }
        else if(vehicleWithAppt.length > 1) {
          popupBodyText = `${this.translate.instant('vehicleManagement.theFollowingVehiclesHaveScheduledTestDriveAppointmentsDoYouStillWantToDeleteThem')}<br>`;
          vehicleWithAppt.forEach(v => {
            popupBodyText += `<br> ${v.vin}`;
          })
        }
        else {
          popupBodyText = 'vehicleManagement.doYouWantToDeleteTheSelectedVehicles';
        }
      }
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        ...this.deleteConfig,
        data: {popupTitle : 'teamManagement.deleteConfirmation', popupBodyText}
      });
      this.subscriptions.deleteConfirmDialog = dialogRef.afterClosed().subscribe(event => {
        if (event.action === 'confirm') {
          if(this.selectedVehicle?.vin && this.selectedVehicles.findIndex(x=> x.vin === this.selectedVehicle?.vin) !== -1){
            this.selectedVehicle = null;
            this.disableForm = true;
          }
          this.vehiclesState.dispatch(new fromActions.DeleteVehicle({vehicles : this.selectedVehicles}));
          this.selectedVehicles=[];
          this.expandedElements =[];
        }
      });
  }

  onBulkStatusChange(targetStatus: boolean) {
    if (!this.isBulkStatusBtnEnable(targetStatus)) {
      return;
    }

    const requestedVehicles = this.getVehiclesForBulkStatusChange(targetStatus).map(vehicle => ({ ...vehicle, status: targetStatus }));
    const payload = this.getBulkStatusPayload(requestedVehicles, targetStatus);

    if (!payload.length) {
      return;
    }

    this.vehiclesState.dispatch(new fromActions.UpdateBulkVehicleStatus({
      requestedVehicles,
      payload,
      status: targetStatus,
      source: this.getBulkStatusSource()
    }));

    this.bulkStatusInProgress = targetStatus;

    this.selectedVehicles = [];
  }

  onRestoreSelected() {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        ...this.deleteConfig,
        data: {popupTitle : 'vehicleManagement.restoreConfirmation', popupBodyText : this.selectedVehicles?.length > 1 ? 'vehicleManagement.doYouWantToRestoreTheSelectedVehicles' : 
        'vehicleManagement.doYouWantToRestoreTheSelectedVehicle'}
      });
      this.subscriptions.restoreDialog = dialogRef.afterClosed().subscribe(event => {
        if (event.action === 'confirm') {
          if(this.selectedVehicle?.vin && this.selectedVehicles.findIndex(x=> x.vin === this.selectedVehicle?.vin) !== -1){
            this.selectedVehicle = null;
            this.disableForm = true;
          }
          this.vehiclesState.dispatch(new fromActions.RestoreVehicle({vehicles : this.selectedVehicles}));
          this.selectedVehicles=[];
        }
      });
  }

  InitializeSearchForm() {
    this.searchForm = this.formBuilder.group({
      modelFilter : [''],
      statusFilter : [''],
      nextTestDriveDateFilter : [''],
      yearFilter : [''],
      makeFilter : [''],
      vinFilter : [''],
      licensePlateFilter : [''],
    })
  }

  addSearchField(columnField, value) {
    const index = this.searchValues.findIndex(x => x?.column === columnField);
    if (!value && columnField === 'nextTestDriveDateFilter') {
      if(index !== -1) {
        this.searchValues.splice(index, 1) 
      }
      else {
        return ;
      }
    }
    if (index === -1) {
      this.searchValues.push({column: columnField, colValue: value});
    } 
    else {
      value ? this.searchValues[index].colValue = value : this.searchValues.splice(index, 1);
    }
    this.searchVehicle();
  }

  onCloseFilterValue(searchColumn, index){
    this.searchValues.splice(index, 1);
    this.searchForm.get(searchColumn).patchValue('');
    this.searchVehicle();
  }

  clearFilters() {
    this.searchValues = [];
    this.InitializeSearchForm();
    this.searchVehicle();
  }

  searchVehicle() {
    const searchData = {...this.searchForm.value};
    searchData.nextTestDriveDateFilter = searchData.nextTestDriveDateFilter ? this.luxonAdapter.parse(searchData.nextTestDriveDateFilter, undefined).toFormat('yyyy-MM-dd') :
    searchData.nextTestDriveDateFilter ;
    this.vehicles = [];
    this.dataSource = new MatTableDataSource(this.vehicles);
    this.isSearchLoading = true;
    this.vehiclesState.dispatch(new fromActions.LoadSearchVehicles({ searchConfig: searchData, view: this.viewMode}));
      this.disableForm = true;
      this.selectedVehicle = null;
      this.expandedElements =[];
      this.selectedVehicles = [];
  }

  isDeleteBtnEnable() {
    return this.selectedVehicles.length && this.selectedVehicles.every(x=> !x.expiredAt);
  }

  isRestoreBtnEnable() {
    return this.selectedVehicles.length && this.selectedVehicles.every(x=> x.expiredAt);
  }

  parsedText(text) {
    const dom = new DOMParser().parseFromString(
    '<!doctype html><body>' + text,
    'text/html');
    const decodedString = dom.body.textContent;
    return decodedString;
  }

  get source() {
    return SourceSystem;
  }

  loadView(view) {
    this.isLoading$.subscribe(value => {
      this.isTabDataLoading = value;
    })
    setTimeout(()=>{                          
      this._contineLoadView(view);
    }, 100);
  }

  _contineLoadView(view){
    if(!this.isTabDataLoading){
      this.viewMode = view;
      if(view !== 'Delete Pending') {
        this.vehiclesState.dispatch(new fromActions.LoadAllVehicles({view: this.viewMode}));
      }
      this.InitializeSearchForm();
      this.disableForm = true;
      this.selectedVehicle = null;
      this.expandedElements =[];
      this.searchValues = [];
      this.allRowsExpanded = false;
      this.selectedVehicles = [];
    }
  }

  ngAfterContentChecked(): void { 
    if (!this.cdr['destroyed']) {
     this.cdr.detectChanges();
   }
  }

 getFormattedDate(date: string) {
  return date ? DateTime.fromFormat(date, 'yyyy-MM-dd').toFormat('MM/dd/yyyy') : '';
}

  ngOnDestroy() {
    this.vehiclesState.dispatch(new fromActions.ResetVehicleState());
    unsubscribeSubscriptions(this.subscriptions);
    clearInterval(this.refreshInterval);
    this.cdr.detach();
  }

}
